import React from 'react';
import { MdExpandLess, MdExpandMore, MdPrint } from 'react-icons/md';
import ReactToPrint from "react-to-print";

import GameContext from './gameContext';
import { NO_RISK } from './gameState';

const NextStepList = (props) => {
  const [checked, setChecked] = React.useState(true);

  const onChange = (e) => {
    setChecked(!checked);
  }

  const id = props.title.replace(/\s/g, "");
  return (
    <div className={`next-step-checkbox ${checked ? "" : "unchecked"}`}>
      <input type="checkbox" id={id} name="next-step-checkbox" checked={checked} onChange={onChange}/>
      <label htmlFor={id}>
        <p>{props.title}</p>
        <ul>
          {props.children}
        </ul>
      </label>
    </div>
  )
}

export const NextSteps = (props) => {
  const gameContext = React.useContext(GameContext);
  const [expanded, setExpanded] = React.useState(true);
  const [printMode, setPrintMode] = React.useState(false);
  let printRef = React.useRef();

  const getNextSteps = (value) => {
    const nextSteps = props.patientSite ? value.patientNextSteps : value.providerNextSteps;
    return nextSteps.map((step, index) => <li key={`${step}${index}`}>{step}</li>);
  }

  const getBodyNextSteps = (value) => {
    const nextSteps = props.patientSite ? value.patientNextSteps : value.providerNextSteps;
    const areNextStepsApplicable = (nextSteps && nextSteps.length > 0 && value.abnormality > 0);
    if (areNextStepsApplicable) {
      return getNextSteps(value);
    }
    return [];
  }

  const getBloodworkNextSteps = (value) => {
    const areNextStepsApplicable = value.abnormality > NO_RISK;
    if (areNextStepsApplicable) {
      return getNextSteps(value);
    }
    return [];
  }

  const getAllNextSteps = () => {
    const lists = [<h3 key="Body">Body</h3>];

    for (const key in gameContext.body) {
      const steps = getBodyNextSteps(gameContext.body[key]);
      if (steps.length > 0) {
        const title = gameContext.body[key].name
        lists.push(
          <NextStepList title={title} key={title}>
            {steps}
          </NextStepList>
        )
      }
    }

    // use `labSteps` so we only push the header text if there are any
    // next steps to take based on labwork
    const labSteps = [];
    for (const key in gameContext.bloodwork) {
      const steps = getBloodworkNextSteps(gameContext.bloodwork[key]);
      if (steps.length > 0) {
        const title = gameContext.bloodwork[key].name
        labSteps.push(
          <NextStepList title={title} key={title}>
            {steps}
          </NextStepList>
        )
      }
    }

    if (labSteps.length) {
      lists.push(<h3 key="Labs"><br/>Potentially Abnormal Labs/Tests</h3>);
      lists.push(...labSteps);
    }

    return lists;
  }

  const startPrint = () => {
    setPrintMode(true);
    printRef.className = "next-steps-printed";
  }

  const endPrint = () => {
    setPrintMode(false);
    printRef.className = "";
  }

  const show = () => {
    setExpanded(true);
  }

  const hide = () => {
    setExpanded(false);
  }

  const nextSteps = getAllNextSteps();
  return (
    <div className="next-steps content-section-boxed">
      <div className="next-steps-header">
        <div>
          <h3>Next Steps</h3>
          <p>
            Based on your input choices, here are some suggested next steps.
            {props.patientSite ? 
             " We encourage you to print this out and take it to your primary care provider." :
             " We encourage you to print this out and speak with your patient about these concerns."
            }
            <br/><br/>
            Only the checked items will appear in the printed copy! Feel free to select the categories
            that feel most relevant to you and your primary concerns.
          </p>
        </div>

        <div>
          {expanded ?
            <>
              <ReactToPrint
                trigger={() => <MdPrint className="action-icon"/>}
                content={() => printRef}
                onBeforeGetContent={startPrint}
                onAfterPrint={endPrint}
                documentTitle="AAS Simulator Next Steps"
                pageStyle={{padding: "40px"}}
              />
              <MdExpandLess className="action-icon" onClick={hide}/>
            </> :
            <MdExpandMore className="action-icon" onClick={show}/>
          }
        </div>
      </div>

      { expanded &&
        <div ref={e => printRef = e}>
          {nextSteps}
        </div>
      }

    </div>
  )
}
